const dev = process.env.NODE_ENV !== 'production'
// this should be the domain
// noinspection JSUnresolvedReference
// Trailing slash trimmed: `PROD_DOMAIN_URL=https://host/` would otherwise yield `https://host//p/x` URLs.
export const server = (dev ? 'https://localhost:3000' : process.env.PROD_DOMAIN_URL)?.replace(
  /\/+$/,
  ''
)
